export const SCHEDULER_TYPES = [
  {
    value: "calendly",
    text: "Calendly",
    icon: "/images/schedulers/calendly.png",
    color: "#006BFF",
  },
  {
    value: "cal",
    text: "Cal.com",
    icon: "/images/schedulers/cal.png",
    color: "#111111",
  },
  {
    value: "hubspot",
    text: "HubSpot Meetings",
    icon: "/images/integrations/hubspot.png",
    color: "#FF7A59",
  },
  {
    value: "gohighlevel",
    text: "GoHighLevel",
    icon: "/images/integrations/gohighlevel.svg",
    color: "#00BDA5",
  },
  {
    value: "chilipiper",
    text: "ChiliPiper",
    icon: "/images/schedulers/chilipiper.png",
    color: "#E23B2A",
  },
  {
    value: "acuity",
    text: "Acuity Scheduling",
    icon: "/images/schedulers/acuity.png",
    color: "#2B59FF",
  },
  {
    value: "savvycal",
    text: "SavvyCal",
    icon: "/images/schedulers/savvycal.png",
    color: "#FF5A1F",
  },
  {
    value: "oncehub",
    text: "OnceHub",
    icon: "/images/schedulers/oncehub.png",
    color: "#00A3E0",
  },
  {
    value: "custom",
    text: "Custom Scheduler URL",
    icon: "/images/schedulers/custom.svg",
    color: "#9CA3AF",
  },
];

export const SCHEDULER_PREFILL_TYPES = [
  "calendly",
  "cal",
  "hubspot",
  "gohighlevel",
  "chilipiper",
  "acuity",
  "savvycal",
  "oncehub",
];

export const CUSTOM_SCHEDULER_BOOKING_EVENT = "convertflow.scheduler.booked";

export const customSchedulerConversionScript = `<script>
(function () {
  window.convertflowTrackBooking = function () {
    try {
      if (window.parent) {
        window.parent.postMessage(
          { event: "${CUSTOM_SCHEDULER_BOOKING_EVENT}" },
          "*"
        );
      }
    } catch (e) {}
  };
  window.convertflowTrackBooking();
})();
</script>`;

export const listedSchedulerType = (type) => {
  return SCHEDULER_TYPES.some((item) => item.value === type) ? type : "custom";
};

export const schedulerTypeLabel = (type) => {
  const match = SCHEDULER_TYPES.find(
    (item) => item.value === listedSchedulerType(type)
  );
  return match ? match.text : "Custom";
};

export const schedulerTypeMeta = (type) => {
  return (
    SCHEDULER_TYPES.find((item) => item.value === listedSchedulerType(type)) ||
    SCHEDULER_TYPES.find((item) => item.value === "custom")
  );
};

export const hexToRgba = (hex, alpha) => {
  const normalized = String(hex || "")
    .replace("#", "")
    .trim();
  if (normalized.length !== 6) return `rgba(156, 163, 175, ${alpha})`;

  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const schedulerPlaceholder = (type) => {
  switch (listedSchedulerType(type)) {
    case "calendly":
      return "https://calendly.com/your-name/30min";
    case "cal":
      return "https://cal.com/your-name/30min";
    case "hubspot":
      return "https://meetings.hubspot.com/your-name";
    case "gohighlevel":
      return "https://api.leadconnectorhq.com/widget/booking/XXXX";
    case "chilipiper":
      return "https://your-org.chilipiper.com/book/router";
    case "acuity":
      return "https://app.acuityscheduling.com/schedule.php?owner=XXXX";
    case "savvycal":
      return "https://savvycal.com/your-name/intro";
    case "oncehub":
      return "https://go.oncehub.com/your-page";
    default:
      return "https://your-scheduler.com/book";
  }
};

const SCHEDULER_HOST_PATTERNS = {
  calendly: [/(^|\.)calendly\.com$/i],
  cal: [/(^|\.)cal\.com$/i],
  hubspot: [/(^|\.)hubspot\.com$/i],
  gohighlevel: [
    /(^|\.)leadconnectorhq\.com$/i,
    /(^|\.)msgsndr\.com$/i,
    /(^|\.)gohighlevel\.com$/i,
    /(^|\.)gethighlevel\.com$/i,
  ],
  chilipiper: [/(^|\.)chilipiper\.com$/i],
  acuity: [/(^|\.)acuityscheduling\.com$/i],
  savvycal: [/(^|\.)savvycal\.com$/i],
  oncehub: [/(^|\.)oncehub\.com$/i, /(^|\.)scheduleonce\.com$/i],
};

const schedulerHostname = (url) => {
  const raw = String(url || "").trim();
  if (!raw) return "";

  try {
    const parsed = new URL(raw.includes("://") ? raw : `https://${raw}`);
    return parsed.hostname.replace(/^www\./i, "");
  } catch (e) {
    return "";
  }
};

export const detectSchedulerTypeFromUrl = (url) => {
  const host = schedulerHostname(url);
  if (!host) return null;

  return (
    Object.keys(SCHEDULER_HOST_PATTERNS).find((type) =>
      SCHEDULER_HOST_PATTERNS[type].some((pattern) => pattern.test(host))
    ) || null
  );
};

export const schedulerUrlMismatchWarning = (type, url) => {
  const detected = detectSchedulerTypeFromUrl(url);
  const selected = listedSchedulerType(type);
  if (!detected || detected === selected) return undefined;

  return `This link doesn't match ${schedulerTypeLabel(
    selected
  )}. It looks like a ${schedulerTypeLabel(detected)} URL.`;
};
